<template>
  <b-modal
    v-if="dataSignos"
    v-model="isVisible"
    size="xl"
    hide-footer
    @cancel="onCancel"
  >
  <b-tabs pills card vertical>
    <b-tab title="Editar Signos">
     
      <b-card border-variant="primary" class="p-2">
        
        <h4 class="mb-2">{{ paciente? paciente.idPaciente : "No disponible" }}</h4>
        <b-row >
          <label class="col-6"><b>Edad del paciente:</b> {{ edadPaciente ? edadPaciente : "No disponible"}}</label>
          <label class="col-6"><b>Fecha de toma:</b> {{ fechaCita ? fechaCita : "No disponible"}}</label>
        </b-row>
        <b-row class="mt-1">
  
          <b-col class="col-6">
            <b-row class="d-flex align-items-center">
              <label 
                for="peso"
                class="col-4"
              >Peso (Kg):</label>
  
              <validation-provider
                #default="{ errors }"
                name="Peso"
                rules="required"
              >
                <b-form-input
                  v-model="signosForm.peso"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Peso (Kg)"
                  type="text"
                  id="peso"
                  maxlength="5"
                  @keypress="(e) => numberDecimal(e, 3, 2)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
  
  
          <b-col class="col-6">
            <b-row class="d-flex align-items-center">
              <label for="talla" class="col-4">Talla (cm):</label>
              <validation-provider
                #default="{ errors }"
                name="Talla"
                rules="required"
              >
                <b-form-input
                  v-model="signosForm.talla"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Talla (cm)"
                  type="text"
                  id="talla"
                  maxlength="3"
                  @keypress="onlyNumbers"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
  
          <b-col class="col-6 my-1">
            <b-row class="d-flex align-items-center">
              <label for="imc" class="col-4">IMC:</label>
              <validation-provider
                #default="{ errors }"
                name="IMC"
                rules="required"
              >
                <b-form-input
                  v-model="signosForm.imc"
                  :state="errors.length > 0 ? false : null"
                  placeholder="IMC"
                  type="number"
                  id="imc"
                  disabled
                  
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
  
          <b-col class="col-6 my-1">
            <b-row class="d-flex align-items-center">
              <label for="temperatura" class="col-4">Temperatura (Cº):</label>
              <validation-provider
                #default="{ errors }"
                name="Temperatura"
                rules="required"
              >
                <b-form-input
                  v-model="signosForm.temperatura"
                  :state="errors.length > 0 ? false : null" 
                  placeholder="Temperatura (Cº)"
                  type="text"
                  id="temperatura"
                  maxlength="5"
                  @keypress="e => numberDecimal(e, 2, 2)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
        </b-row>
  
        <hr>
  
        <b-row class="my-2">
  
          <b-col class="col-6">
            <b-row class="d-flex align-items-center">
              <label for="freqRespiratoria" class="col-5">
                Frecuencia Respiratoria (resp/min):
              </label>
              <validation-provider
                #default="{ errors }"
                name="FrecuenciaRespiratoria"
                rules="required"
              >
                <b-form-input
                  v-model="signosForm.freqRespiratoria"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Frecuencia Respiratoria (resp/min)"
                  type="text"
                  id="freqRespiratoria"
                  maxlength="3"
                  @keypress="onlyNumbers"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
  
  
          <b-col class="col-6">
            <b-row class="d-flex align-items-center">
              <label for="satOxigeno" class="col-5">
                Saturación de Oxígeno (%):
              </label>
              <validation-provider
                #default="{ errors }"
                name="Saturacion"
                rules="required"
              >
                <b-form-input
                  v-model="signosForm.satOxigeno"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Saturación de Oxígeno (%)"
                  type="text"
                  id="satOxigeno"
                  @keypress="onlyNumbers"
                  maxlength="2"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
  
          <b-col class="col-6 my-1">
            <b-row class="d-flex align-items-center">
              <label for="tensionArterial" class="col-5">
                Tensión Arterial (mm Hg):
              </label>
              
              <b-input-group class="col pl-0">
                <b-form-input
                  v-model="signosForm.tensionArterialSistolica"
                  placeholder="Sistolica"
                  type="text"
                  maxlength="3"
                  @keypress="onlyNumbers"
                />
            
                <b-form-input
                  v-model="signosForm.tensionArterialDiastolica"
                  placeholder="Diastolica"
                  type="text"
                  maxlength="3"
                  @keypress="onlyNumbers"
                />
              </b-input-group>
            </b-row>
          </b-col>
  
          <b-col class="col-6 my-1">
            <b-row class="d-flex align-items-center">
              <label for="pulso" class="col-5">
                Pulso (latidos/min):
              </label>
              <validation-provider
                #default="{ errors }"
                name="Pulso"
                rules="required"
              >
                <b-form-input
                  v-model="signosForm.pulso"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Pulso (latidos/min)"
                  type="text"
                  maxlength="3"
                  @keypress="onlyNumbers"
                  id="pulso"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
        </b-row>
  
        <hr>
  
        <b-row class="my-2">
          <h5 class="col-12 my-1">Otros Signos Vitales</h5>
          <b-col class="col-6">
            <b-row>
              <label for="perimetroCefalico" class="col-5">
                Perímetro Cefálico (cm):
              </label>
              <validation-provider
                class="col-4"
                #default="{ errors }"
                name="PerimetroCefalico"
              >
                <b-form-input
                  v-model="dataSignos.perimetroCefalico"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Perímetro Cefálico (cm)"
                  type="text"
                  maxlength="3"
                 
                  id="perimetroCefalico"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
  
  
          <b-col class="col-6">
            <b-row>
              <label for="perimetroAbdominal" class="col-5">
                Perímetro Abdominal (cm):
              </label>
              <validation-provider
                class="col-4"
                #default="{ errors }"
                name="PerimetroAbdominal"
              >
                <b-form-input
                  v-model="dataSignos.perimetroAbdominal"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Perímetro Abdominal (cm)"
                  type="text"
                  maxlength="3"
                  
                  id="perimetroAbdominal"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-row>
          </b-col>
        </b-row>
  
        <b-row class="mt-3">
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="onSaveSignoVitales()"
              :disabled="!disabledButtonUpdate"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>
  
      </b-card>
    </b-tab>
    <b-tab title="Historial">
      <InfoSignosVitales :idPaciente="idPaciente"
            :idCitaActual="dataCita.id"/>
    </b-tab>
  </b-tabs>
    
  </b-modal>
  
</template>
 
<script>
import { ValidationProvider } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios';
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import rutas from '@/assets/utils/rutas.json';
import { required } from '@validations'
import Swal from "sweetalert2";
import { numberDecimal, onlyNumbers } from "@/shared/helpers";
import InfoSignosVitales from '../atencionCita/components/InfoSignosVitales/InfoSignosVitales.vue';


export default {

  name: 'SignoModalEdit',

  components: {
    ValidationProvider,
  },

  props:{
    dataSignos:Object,
    paciente:Object,
    edadPaciente: {
      default : 0,
      required : false
    },
    fechaCita: {
      default : 0,
      required : false
    }
  },


  data() {
    return {
      mensajes: {
        freqRespiratoria : null,
        imc:null,
        temperatura:null,
        satOxigeno:null,
        pulso:null,
        tensionArterial:null
      },
      isVisible:true,
      required,
      disabledButtonUpdate:false,

      signosForm:{
        talla: null,
        peso: null,
        imc: null,
        tensionArterialSistolica: null,
        tensionArterialDiastolica: null,
        pulso: null,
        perimetroCefalico: null,
        perimetroAbdominal: null,
        freqRespiratoria:null,
        temperatura:null,
        satOxigeno:null
      },

      onlyNumbers,
      numberDecimal
    }
  },


  created() {
  },
 
     
  methods: {
       
    alertaTension(sistolica, diastolica, edad) {
      if (sistolica && diastolica) {
        // const rangosTension = [
        //   { minEdad: 0,  maxEdad: 0,        minSistolica: 70,  maxSistolica: 100, minDiastolica: 50, maxDiastolica: 70 },
        //   { minEdad: 1,  maxEdad: 5,        minSistolica: 80,  maxSistolica: 110, minDiastolica: 50, maxDiastolica: 80 },
        //   { minEdad: 6,  maxEdad: 12,       minSistolica: 90,  maxSistolica: 120, minDiastolica: 60, maxDiastolica: 80 },
        //   { minEdad: 13, maxEdad: 18,       minSistolica: 110, maxSistolica: 131, minDiastolica: 64, maxDiastolica: 83 },
        //   { minEdad: 19, maxEdad: 64,       minSistolica: 90,  maxSistolica: 140, minDiastolica: 60, maxDiastolica: 80 },
        //   { minEdad: 65, maxEdad: Infinity, minSistolica: 90,  maxSistolica: 140, minDiastolica: 60, maxDiastolica: 90 }
        // ];

        const rangosTension = [
          { minEdad: 0,  maxEdad: 0,        minSistolica: 55,  maxSistolica: 100, minDiastolica: 35, maxDiastolica: 65 },
          { minEdad: 1,  maxEdad: 3,        minSistolica: 90,  maxSistolica: 105, minDiastolica: 55, maxDiastolica: 70 },
          { minEdad: 6,  maxEdad: 12,       minSistolica: 100, maxSistolica: 120, minDiastolica: 60, maxDiastolica: 75 },
          { minEdad: 13, maxEdad: Infinity, minSistolica: 110, maxSistolica: 135, minDiastolica: 65, maxDiastolica: 85 }
        ];

        // Encontrar el rango de tensión correspondiente
        const rango = rangosTension.find(r => edad >= r.minEdad && edad <= r.maxEdad);

        // Verificar si la tensión está dentro del rango
        const dentroDelRango = sistolica >= rango.minSistolica && sistolica <= rango.maxSistolica &&
                              diastolica >= rango.minDiastolica && diastolica <= rango.maxDiastolica;

        // Mostrar mensaje en función del resultado
        const mensaje = dentroDelRango 
          ? "tension arterial dentro del rango" 
          : "Tension arterial fuera del rango de normalidad";
        this.mensajes.tensionArterial = !dentroDelRango ?  "Tension arterial" : null
        //this.$toast[dentroDelRango ? "success" : "error"](mensaje);
      }
    },

    onCancel() {
      this.$emit('update:dataSignos', null);
      this.isVisible = false;
    },

    hasChangeValues(){
      return JSON.stringify(this.dataSignos) !== JSON.stringify(this.signosForm);
    },
 
    calcularIMC(talla, peso) {
      if (!talla && !peso) return null;
      const imcRaw = (parseFloat(peso) / (parseFloat(talla) * parseFloat(talla))) * 10000;
      return parseFloat(imcRaw.toFixed(2));
    },

    showToastSuccess() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Signos Vital Editado',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },
         

    async onSaveSignoVitales(){
      if (this.signosForm.talla && this.signosForm.talla.length === 1 || this.signosForm.peso && this.signosForm.peso.length === 1 
      || this.signosForm.temperatura && this.signosForm.temperatura.length === 1 || this.signosForm.freqRespiratoria && this.signosForm.freqRespiratoria.length === 1
      || this.signosForm.satOxigeno && this.signosForm.satOxigeno.length === 1 || this.signosForm.pulso && this.signosForm.pulso.length === 1 || this.signosForm.tensionArterialDiastolica && this.signosForm.tensionArterialDiastolica.length === 1
      || this.signosForm.tensionArterialSistolica && this.signosForm.tensionArterialSistolica.length === 1) {
          this.$swal({
            title: 'Error',
            text: 'Un dato que ingreso no esta bien llenado',
            icon: 'error',
            confirmButtonColor: '#089599',
          }); return }
      let timerInterval;
        Swal.fire({
          title : "Guardando...",
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            timerInterval = setInterval(() => {
              const timer = Swal.getTimerLeft();
              if (timer) {
                Swal.getContent().querySelector("b").textContent = `${timer}`;
              }
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          }
        });

        const response = await this.actualizarSignosVital();
        
        Swal.close();

      

      if(response?.status === 200){

        this.$swal({
          title: 'Actualizado',
          text : 'Signos Vitales ha sido actualizado',
          icon : 'success',
        });
        this.showToastSuccess();
        this.onCancel();

      }else {
        this.$swal({
          title: 'Error',
          text: 'Error en actualizar signos: ',
          icon: 'error',
          confirmButtonColor: '#089599',
        })
      }
      

    },
 
    async actualizarSignosVital(){
    
      
      try{  
        const argSignosVital = {
          id                : this.signosForm.id,
          temperatura       : parseFloat(this.signosForm.temperatura),
          peso              : parseFloat(this.signosForm.peso),
          talla             : parseFloat(this.signosForm.talla),
          tensionArterialSistolica : parseFloat(this.signosForm.tensionArterialSistolica),
          tensionArterialDiastolica: parseFloat(this.signosForm.tensionArterialDiastolica),
          imc               : parseFloat(this.signosForm.imc),
          pulso             : parseFloat(this.signosForm.pulso),
          freqRespiratoria  : parseFloat(this.signosForm.freqRespiratoria),
          satOxigeno        : parseFloat(this.signosForm.satOxigeno),
          perimetroCefalico : parseFloat(this.signosForm.perimetroCefalico),
          perimetroAbdominal: parseFloat(this.signosForm.perimetroAbdominal),
        };

        const response = await axios.post(rutas.axios + 'api', {
          query: `
            mutation editarSignosvital(
              $id: String!
              $temperatura: Float
              $peso: Float
              $tensionArterialSistolica: Float
              $tensionArterialDiastolica: Float
              $imc: Float
              $pulso: Float
              $freqRespiratoria: Float
              $satOxigeno: Float
              $perimetroCefalico: Float
              $talla: Float
              $perimetroAbdominal: Float
            ) {
              editarSignosvital(
                  id: $id
                  temperatura: $temperatura
                  peso: $peso
                  tensionArterialSistolica: $tensionArterialSistolica
                  tensionArterialDiastolica: $tensionArterialDiastolica
                  imc: $imc
                  pulso: $pulso
                  freqRespiratoria: $freqRespiratoria
                  satOxigeno: $satOxigeno
                  perimetroCefalico: $perimetroCefalico
                  talla: $talla
                  perimetroAbdominal: $perimetroAbdominal
              ) {
                  status
                  message
                  signosVital {
                      id
                      temperatura
                      peso
                      tensionArterialSistolica
                      tensionArterialDiastolica
                      imc
                      pulso
                      freqRespiratoria
                      satOxigeno
                      perimetroCefalico
                      talla
                      perimetroAbdominal
                  }
              }
            }
          `,
          variables: argSignosVital
        });
        return response;
      }catch (error) {
        console.log('Error signos update process:', error);
        return error;
      }
    },

    handlerPulso(newVal){
      const rangosEdad = [
          { minEdad: 0,  maxEdad: 0,        minPulso: 90, maxPulso: 170 },
          { minEdad: 1,  maxEdad: 3,        minPulso: 80, maxPulso: 150 },
          { minEdad: 4,  maxEdad: 6,        minPulso: 80, maxPulso: 140 },
          { minEdad: 7,  maxEdad: 12,       minPulso: 60, maxPulso: 100 },
          { minEdad: 13, maxEdad: Infinity, minPulso: 60, maxPulso: 110 },
        ];

        const rango = rangosEdad.find(r => this.edadPaciente >= r.minEdad && this.edadPaciente <= r.maxEdad);
        
        this.mensajes.pulso = !(newVal >= rango.minPulso && newVal <= rango.maxPulso) ? "Pulso" : null
        
    },

    handlerTemperatura(newVal){
      const rangosTemperatura = [
          { minEdad: 0,  maxEdad: 0,        minTemp: 36.1, maxTemp: 37.7 },
          { minEdad: 1,  maxEdad: 2,        minTemp: 36.1, maxTemp: 37.2 },
          { minEdad: 3,  maxEdad: 8,        minTemp: 36.1, maxTemp: 37.0 },
          { minEdad: 9, maxEdad: Infinity,  minTemp: 36.0, maxTemp: 37.0 }
        ];

        const rango = rangosTemperatura.find(r => this.edadPaciente >= r.minEdad && this.edadPaciente <= r.maxEdad);

        const mensaje = (newVal >= rango.minTemp && newVal <= rango.maxTemp)
          ? "Temperatura dentro del rango"
          : "Temperatura fuera del rango de normalidad";
        
        this.mensajes.temperatura = !(newVal >= rango.minTemp && newVal <= rango.maxTemp) ? "Temperatura " : null
    },

    handlerImc(newVal){
      if (newVal < 20 || newVal > 30) {
        console.log("entra aqui")
        mensaje = "IMC"
        this.mensajes.imc = mensaje
        //this.$toast.error("El IMC fuera del rango de normalidad");
      }else{
        mensaje = "El IMC esta dentro del rango"
        this.mensajes.imc = null
        //this.$toast.success("IMC dentro del rango");
      }
    },
    handlerFreqRespiratoria(newVal){
      
      const rangosEdad = [
          { minEdad: 0,  maxEdad: 0,         minFreq: 40, maxFreq: 70 },
          { minEdad: 1,  maxEdad: 3,         minFreq: 22, maxFreq: 30 },
          { minEdad: 4,  maxEdad: 6,         minFreq: 20, maxFreq: 24 },
          { minEdad: 7,  maxEdad: 12,        minFreq: 16, maxFreq: 22 },
          { minEdad: 13, maxEdad: Infinity,  minFreq: 12, maxFreq: 20 }
        ];

        const rango = rangosEdad.find(r => this.edadPaciente >= r.minEdad && this.edadPaciente <= r.maxEdad);

        const mensaje = (newVal >= rango.minFreq && newVal <= rango.maxFreq)
          ? "Frecuencia respiratoria dentro del rango"
          : "Frecuencia respiratoria ";
        this.mensajes.freqRespiratoria = !(newVal >= rango.minFreq && newVal <= rango.maxFreq) ? mensaje : null
    },

    handlerSatOxigeno(newVal){
      const rangosSaturacion = {
          menorDe1: { min: 93, max: 100 },
          mayorDe1: { min: 93, max: 100 }
        };

        const { min, max } = this.itemCita.edad < 1 
          ? rangosSaturacion.menorDe1 
          : rangosSaturacion.mayorDe1;

        const mensaje = (newVal >= min && newVal <= max)
          ? "Saturacion dentro del rango"
          : "Saturacion Oxigeno";

          this.mensajes.satOxigeno = !(newVal >= min && newVal <= max) ? mensaje : null
        //this.$toast[(newVal >= min && newVal <= max) ? 'success' : 'error'](mensaje);
    }




          
  },

  watch: {
    dataSignos:{
      deep: true,
      handler(newValue) {
        this.signosForm = { ...newValue };
        this.isVisible = true;
      }
    },

    'signosForm.talla'(newValue){
      this.signosForm.imc = this.calcularIMC(newValue, this.signosForm.peso)
    },
    'signosForm.peso'(newValue){
      this.signosForm.imc = this.calcularIMC(this.signosForm.talla, newValue)
    },

    
    signosForm:{
    deep:true,
    immediate:true,
    handler(newValue){

      this.disabledButtonUpdate = this.hasChangeValues();

      if(newValue.pulso){
        this.handlerPulso(newValue.pulso)
      }
      if(newValue.temperatura){
        this.handlerTemperatura(newValue.temperatura)
      }
      if(newValue.imc){
        this.handlerImc(newValue.imc)
      }
      if(newValue.freqRespiratoria){
        this.handlerFreqRespiratoria(newValue.freqRespiratoria)
      }
      if(newValue.satOxigeno){
        this.handlerSatOxigeno(newValue.satOxigeno)
      }
      if(newValue.talla){
        this.handlerTalla(newValue.talla)
      }
      if(newValue.peso){
        this.handlerPeso(newValue.peso)
      }
      if(newValue.tensionArterialSistolica && newValue.tensionArterialDiastolica){
        this.alertaTension(newValue.tensionArterialSistolica, newValue.tensionArterialDiastolica, this.edadPaciente)
      }
     
    }
    },
   


    mensajes:{
      deep:true,
      immediate:true,
      handler(newValue){
        if(newValue){
          // console.log("cambio", newValue)
        }
     
      }
    
    
    }
  },


}
</script>
